module.exports = __webpack_public_path__ + "img/image_0_1.b3a8c5ef.png";